import { fork } from "@redux-saga/core/effects";

import authSaga from "./auth/sagas";
import apiSaga from "./api/sagas";
import agentSaga from "./agent/sagas";
import agentStaffSaga from "./agentStaff/sagas";
import partnerSaga from "./partner/sagas";
import staffSaga from "./staff/sagas";
import accountSaga from "./accounts/sagas";
import logsSaga from "./logs/sagas";
import tarrifSaga from "./tarrif/sagas";
import merchantSaga from "./merchant/sagas";

export default function* root() {
  yield fork(authSaga);
  yield fork(apiSaga);
  yield fork(agentSaga);
  yield fork(partnerSaga);
  yield fork(staffSaga);
  yield fork(agentStaffSaga);
  yield fork(accountSaga);
  yield fork(logsSaga);
  yield fork(tarrifSaga);
  yield fork(merchantSaga);
}
